// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;The Lord shall make good his purpose for me;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;your loving-kindness, O Lord, endures for ever;<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;forsake not the work of your hands.<br> </p> </div></div>";
// Exports
module.exports = code;